import * as tslib_1 from "tslib";
import { infoBarAddHandler, infoBarRemoveHandler } from './infoBarHandlers';
import { lazyDeleteAttachmentsViaQueueManager } from 'owa-attachment-well-data';
import { getCurrentTableMailboxInfo } from 'owa-mail-mailboxinfo';
export default function deletePendingInlineAttachment(placeholderId, composeViewState) {
    if (!composeViewState.attachmentWell || !composeViewState.attachmentWell.inlineAttachments) {
        return;
    }
    // Find an inlineAttachment with the matching placeholderId that is currently pending
    var attachmentViewState = null;
    for (var i = 0; i < composeViewState.attachmentWell.inlineAttachments.length; ++i) {
        var inlineAttachment = composeViewState.attachmentWell.inlineAttachments[i];
        if (inlineAttachment.placeholderId == placeholderId &&
            inlineAttachment.status === 0 /* Initialized */) {
            attachmentViewState = inlineAttachment;
            break;
        }
    }
    // If a matching pending inline attachment was found, use the attachments queue manager to delete it
    if (attachmentViewState) {
        var parentItemId = tslib_1.__assign({}, composeViewState.itemId, { mailboxInfo: getCurrentTableMailboxInfo() });
        lazyDeleteAttachmentsViaQueueManager.importAndExecute(composeViewState.attachmentWell, attachmentViewState, parentItemId, infoBarAddHandler(composeViewState), infoBarRemoveHandler(composeViewState));
    }
}
//# sourceMappingURL=deletePendingInlineAttachment.js.map